<div class="modal-body p-4 p-lg-5">
  <div class="text-center mb-5">
    <div
      class="d-inline-flex align-items-center justify-content-center bg-primary-subtle text-primary rounded-circle mb-3"
      style="width: 60px; height: 60px"
    >
      <i class="bi bi-person-plus-fill fs-2" style="font-size: 4em"></i>
    </div>
    <h3 class="fw-bold text-dark">Daftar Akun Baru</h3>
  </div>

  <form [formGroup]="registerForm" (ngSubmit)="register()" autocomplete="off">
    <div class="row g-3 mb-3">
      <div class="col-md-6">
        <div>
          <label for="name" class="form-label">Nama Lengkap</label>
          <input
            type="text"
            class="form-control"
            id="name"
            formControlName="name"
            placeholder="Masukkan nama lengkap"
            [class.is-invalid]="f['name'].invalid && f['name'].touched"
          />
          @if (f['name'].invalid && f['name'].touched) {
          <div class="invalid-feedback">Nama wajib diisi.</div>
          }
        </div>
      </div>

      <div class="col-md-6">
        <div>
          <label for="email" class="form-label">Alamat Email</label>
          <input
            type="email"
            class="form-control"
            id="email"
            formControlName="email"
            placeholder="nama@contoh.com"
            [class.is-invalid]="f['email'].invalid && f['email'].touched"
          />
          @if (f['email'].invalid && f['email'].touched) {
          <div class="invalid-feedback">Format email tidak valid.</div>
          }
        </div>
      </div>
    </div>

    <div class="row g-3 mb-3">
      <div class="col-md-6">
        <div>
          <label for="phone" class="form-label">No. Handphone</label>
          <input
            type="text"
            class="form-control"
            id="phone"
            formControlName="phone"
            placeholder="08xxxxxxxxxx"
            [class.is-invalid]="f['phone'].invalid && f['phone'].touched"
          />
          @if (f['phone'].invalid && f['phone'].touched) {
          <div class="invalid-feedback">No. HP wajib diisi (Angka).</div>
          }
        </div>
      </div>

      <div class="col-md-6">
        <div>
          <label for="birthDate" class="form-label">Tanggal Lahir</label>
          <input
            type="date"
            class="form-control"
            id="birthDate"
            formControlName="birthDate"
            [class.is-invalid]="
              f['birthDate'].invalid && f['birthDate'].touched
            "
          />
          @if (f['birthDate'].invalid && f['birthDate'].touched) {
          <div class="invalid-feedback">Tanggal lahir wajib diisi.</div>
          }
        </div>
      </div>
    </div>

    <div class="row g-3 mb-3">
      <div class="col-md-6">
        <div>
          <label for="idtype" class="form-label">Tipe ID</label>
          <select
            class="form-select"
            id="idtype"
            formControlName="idtype"
            [class.is-invalid]="f['idtype'].invalid && f['idtype'].touched"
          >
            <option value="NIK">NIK (KTP)</option>
            <option value="Passport">Passport</option>
          </select>
        </div>
      </div>

      <div class="col-md-6">
        <div>
          <label for="identity" class="form-label">Nomor Identitas</label>
          <input
            type="text"
            class="form-control"
            id="identity"
            formControlName="identity"
            placeholder="Masukkan nomor identitas"
            [class.is-invalid]="f['identity'].invalid && f['identity'].touched"
          />
          <div class="invalid-feedback">Nomor identitas wajib diisi.</div>
          @if (f['identity'].invalid && f['identity'].touched) { }
        </div>
      </div>
    </div>

    <div class="row g-3 mb-4">
      <div class="col-md-6">
        <div class="position-relative">
          <label for="regPassword" class="form-label">Password</label>
          <input
            [type]="hidePass() ? 'password' : 'text'"
            class="form-control"
            id="regPassword"
            formControlName="password"
            placeholder="Minimal 6 karakter"
            [class.is-invalid]="f['password'].invalid && f['password'].touched"
          />
          @if (f['password'].invalid && f['password'].touched) {
          <div class="invalid-feedback">Min. 6 karakter.</div>
          }
        </div>
      </div>

      <div class="col-md-6">
        <div class="position-relative">
          <label for="confirmPassword" class="form-label"
            >Konfirmasi Password</label
          >
          <input
            [type]="hideConfirmPass() ? 'password' : 'text'"
            class="form-control"
            id="confirmPassword"
            formControlName="confirmPassword"
            placeholder="Ketik ulang password"
            [class.is-invalid]="
              (f['confirmPassword'].invalid ||
                registerForm.hasError('mismatch')) &&
              f['confirmPassword'].touched
            "
          />

          @if (registerForm.hasError('mismatch') &&
          f['confirmPassword'].touched) {
          <div class="invalid-feedback">Password tidak sama.</div>
          }
        </div>
      </div>
    </div>

    <button
      type="submit"
      class="btn btn-primary w-100 py-2 rounded-pill fw-bold shadow-sm"
      [disabled]="registerForm.invalid || loading()"
    >
      @if (loading()) {
      <span class="spinner-border spinner-border-sm me-2"></span> Memproses... }
      @else { Daftar Sekarang }
    </button>

    <div class="text-center mt-3">
      <span class="small text-muted">Sudah punya akun? </span>
      <a
        href="javascript:void(0)"
        (click)="openLoginModal()"
        class="small text-primary text-decoration-none fw-medium"
      >
        Masuk Sekarang
      </a>
    </div>
  </form>
</div>
